/**
 * Tajikistani somoni.
 */
export var TJS = {
  code: 'TJS',
  base: 10,
  exponent: 2
};